import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-asset",
  "use": "icon-add-asset-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-add-asset\"><path fill-rule=\"evenodd\" d=\"M8 2.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 .78a4.72 4.72 0 1 0 0 9.44 4.72 4.72 0 0 0 0-9.44m.458 1.787v2.477h2.292v.842H8.458v2.565h-.916V8.386H5.25v-.842h2.292V5.067z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol